export default __webpack_public_path__ + "static/media/comingSoonThumbnail.9dc3966c.jpg";